export interface ParkingWarning {
    code: string;
    message: string;
}

export interface ParkingAssignment {
    invitationUid: string | null;
    email: string;
    userName: string | null;
    isSubinvitation: boolean;
    begin: string | null;
    end: string | null;
    warnings: ParkingWarning[];
}

export const DEFAULT_MAX_ASSIGNMENTS = 1;

export function ParkingSpot({
    uid = '',
    number = '',
    floor = '',
    locationUid = '',

    holderUserUid = null as string | null,
    holderName = null as string | null,
    holderEmail = null as string | null,
    holderInvitationUid = null as string | null,
    holderInvitationReused = false,

    assignments = [] as ParkingAssignment[],
    maxAssignments = DEFAULT_MAX_ASSIGNMENTS,

    notes = '',
    warnings = [] as ParkingWarning[],
    edited = false,
} = {}) {
    return {
        uid,
        number,
        floor,
        locationUid,
        holderUserUid,
        holderName,
        holderEmail,
        holderInvitationUid,
        holderInvitationReused,
        assignments,
        maxAssignments,
        notes,
        warnings,
        edited,
    };
}

export type ParkingSpotType = ReturnType<typeof ParkingSpot>;

export interface ParkingFilter {
    floor?: string | null;
    status?: 'ALL' | 'FREE' | 'OCCUPIED';
    searchTerm?: string;
}
